const disputeService = require('./disputeService')
import Vue from 'vue'
import { negligenceFilterOptions, removeEmptyNegligenceParam } from './negligenceFilter'

const state = {
  disputes: [],
  isDisputeLoading: false,
}

const getters = {
  disputes: (state) => state.disputes,
  isDisputeLoading: (state) => state.isDisputeLoading,
  disputeStatus: (_state, _getters, _rootState, rootGetters) => {
    const i18n = rootGetters['i18n'] || Vue.prototype.$t
    return [
      { name: i18n('dispute.status.PENDING'), value: 'PENDING' },
      { name: i18n('dispute.status.FINISHED'), value: 'FINISHED' },
    ]
  },

  ownerTypeOptions: (_state, _getters, _rootState, rootGetters) => {
    const i18n = rootGetters['i18n'] || Vue.prototype.$t
    return [
      { name: i18n('dispute.ownerType.HAUSEFUL'), value: 'HAUSEFUL' },
      { name: i18n('dispute.ownerType.CUSTOMER'), value: 'CUSTOMER' },
      { name: i18n('dispute.ownerType.SERVICE_PROVIDER'), value: 'SERVICE_PROVIDER' },
    ]
  },

  slaBreachedOptions: (_state, _getters, _rootState, rootGetters) => {
    const i18n = rootGetters['i18n'] || Vue.prototype.$t
    return [
      { name: i18n('dispute.filters.slaBreachedOnly'), value: true },
    ]
  },

  negligenceOptions: (_state, _getters, _rootState, rootGetters) => {
    const i18n = rootGetters['i18n'] || Vue.prototype.$t
    return negligenceFilterOptions(i18n)
  },
}

const actions = {
  async fetchDisputes({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)
    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage
    }
    const params = { ...defaultParams, ...rootState.filters.filters }
    if (!params.ownerType) delete params.ownerType
    if (!params.slaBreached) delete params.slaBreached
    removeEmptyNegligenceParam(params)

    disputeService
      .list(params)
      .then(({ data }) => {
        const { result, total } = data

        commit('setDisputes', result)
        commit('setTotalPages', total)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },
}

const mutations = {
  setDisputes: (state, disputes) => {
    state.disputes = disputes
  },

  setIsDisputeLoading: (state, status) => {
    state.isDisputeLoading = status
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
